import { BaseAPI } from './BaseAPI.js'
import { Workflow } from '../types/WorkFlow.js'

export default class WorkflowAPI extends BaseAPI<Workflow> {
  override get resource(): string {
    return '/workflows'
  }

  public test(id: number, data: any) {
    return this._client.post<{ data: any }>(`${this.resource}/${id}/test`, data)
  }
}